import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealAddressEntity } from '../../domain/entities/MealAddressEntity'
import type { MealAddressAdminDto } from '@/backend/market'

export class MealAddressModel extends MealAddressEntity {
  constructor(dataDto: MealAddressAdminDto) {
    super()
    mapEntityProperties<MealAddressEntity>(this, dataDto)
  }
}
